import { useTextDomainContext } from "@/app/providers";
import React, { useContext } from "react";
import {
  BlueButtonStyleHeading,
  CountryTimezoneForm,
  ModalBox,
} from "@/components";
import { Typography } from "@mui/material";
import { getPartnerName } from "@/utils";
import { Box } from "@mui/system";
import { bool, func } from "prop-types";

type CountryTimezoneModalProps = {
  open: boolean;
  handleClose: () => void;
};

export const CountryTimezoneModal = (props: CountryTimezoneModalProps) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const partnerName = getPartnerName();

  return (
    <ModalBox open={props.open} handleClose={props.handleClose}>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.grey[50],
          p: 4,
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            pb: 3,
          }}
        >
          <BlueButtonStyleHeading>
            {gettext("Account Setup")}
          </BlueButtonStyleHeading>
        </Box>

        <Typography sx={{}}>
          {gettext(
            "Please provide the required details to complete your account setup and get started.",
          )}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.grey[100],
          p: 4,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            textAlign: "center",
            pb: 4,
          }}
        >
          {gettext("Welcome to")} {partnerName}
        </Typography>
        <CountryTimezoneForm handleClose={props.handleClose} />
      </Box>
    </ModalBox>
  );
};

CountryTimezoneModal.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
};

export const AccountSetupModal = CountryTimezoneModal;
